module.exports = __webpack_public_path__ + "img/3-6.028c0729.png";